/** @jsx jsx */
import { jsx } from '@emotion/core';
import BackToTop from '../../ui/BackToTop';
import PropTypes from 'prop-types';
import ProgressBar from '../../ui/ProgressBar';
import { ParentDimensionsProps } from './commonPropTypes';
import { SafePureComponent } from '../../../utils/SafePureComponent';
import {
  onlyMdAndBelowCss,
  stickyParentCss,
  stickyBackToTopCss,
  stickyProgressBar,
} from './index.styles';

class StickyMobile extends SafePureComponent {
  safeRender() {
    const { parentDimensions } = this.props;

    return (
      <div css={[onlyMdAndBelowCss, stickyParentCss]}>
        <ProgressBar
          css={stickyProgressBar}
          percentage={parentDimensions.scrolledPercentage}
        />
        <BackToTop css={stickyBackToTopCss} />
      </div>
    );
  }
}

StickyMobile.displayName = 'StickyMobile';

StickyMobile.defaultProps = {
  parentDimensions: {
    top: 0,
    bottom: 0,
    scrolledPercentage: 0,
  },
};

StickyMobile.propTypes = {
  rendering: PropTypes.shape({
    fields: PropTypes.shape({
      Headline: PropTypes.object,
      Section: PropTypes.object,
      Subsection: PropTypes.object,
    }),
  }),
  parentDimensions: ParentDimensionsProps,
};

export default StickyMobile;
